<div class="modal-backdrop fade" *ngIf="openVerifyOTP" [class.show]="openVerifyOTP"></div>
<div class="modal fade" *ngIf="openVerifyOTP" [ngClass]="{'show displayBlock' : openVerifyOTP}"
    [class.displayBlock]="openVerifyOTP">
    <div class="modal-dialog signin-modal">
        <div class="modal-content">
            <div class=" card p-0 signin-card">
                <div class="row g-0 h-100">
                    <div class="col-md-5 h-100">
                        <div class="signin-info h-100 d-flex justify-content-around flex-column align-items-center">
                            <h1>Tenders Made Easy To Search</h1>
                            <h2>Search any Tender by Location, Category, Organization, High Value, Low value, Fresh Bid
                            </h2>
                            <img loading="lazy" src="https://d1tiqtcifmy0l7.cloudfront.net/prod/icons/signin-1.svg"
                                alt="">
                        </div>
                    </div>
                    <div class="col-md-7">
                        <button type="button" (click)="closeModal()"
                            class="btn-close-1 close pull-right d-flex align-items-center jusity-content-center"
                            aria-label="Close">
                            <i class="sprite-img-header-footer black-cross-circle"></i>
                        </button>
                        <div
                            class="card-body signin-button-section h-100 d-flex align-items-start justify-content-center jusity-content-center">
                            <div class="text-start w-100">
                                <h5 class="card-title">Enter 6 digit OTP</h5>
                                <div class="d-flex justify-content-between">
                                    <p class="card-text">OTP sent to {{mobileNumber}} <br> for verification.</p>
                                </div>
                                <div class="mb-3">
                                    <div class="digit-group">
                                        <div class="digit-group otp-not-verified">
                                            <input type="text" id="digit-1" maxlength="1" placeholder="-" name="digit-1"
                                                (input)="onOtpInputChange(1, $event)"
                                                (keydown)="onOtpKeyDown(1, $event)" inputmode="numeric" />
                                            <input type="text" id="digit-2" maxlength="1" placeholder="-" name="digit-2"
                                                (input)="onOtpInputChange(2, $event)"
                                                (keydown)="onOtpKeyDown(2, $event)" inputmode="numeric" />
                                            <input type="text" id="digit-3" maxlength="1" placeholder="-" name="digit-3"
                                                (input)="onOtpInputChange(3, $event)"
                                                (keydown)="onOtpKeyDown(3, $event)" inputmode="numeric" />
                                            <input type="text" id="digit-4" maxlength="1" placeholder="-" name="digit-4"
                                                (input)="onOtpInputChange(4, $event)"
                                                (keydown)="onOtpKeyDown(4, $event)" inputmode="numeric" />
                                            <input type="text" id="digit-5" maxlength="1" placeholder="-" name="digit-5"
                                                (input)="onOtpInputChange(5, $event)"
                                                (keydown)="onOtpKeyDown(5, $event)" inputmode="numeric" />
                                            <input type="text" id="digit-6" maxlength="1" placeholder="-" name="digit-6"
                                                (input)="onOtpInputChange(6, $event)"
                                                (keydown)="onOtpKeyDown(6, $event)" inputmode="numeric" />
                                        </div>
                                    </div>

                                    <div class="mb-3 d-flex justify-content-between align-items-center">
                                        <div class="otp-coundown d-flex flex-column">
                                            <span>Didn’t receive the code?</span>
                                            <strong>Resend in 00:{{ countdown < 10 ? '0' + countdown : countdown
                                                    }}</strong>
                                        </div>
                                        <button class="blue-button" [disabled]="countdown > 0"
                                            (click)="resendOtp()">RESEND OTP</button>
                                    </div>

                                    <div *ngIf="otpIncorrect" class="exhausted-error-message">
                                        {{ errorMessage }}
                                      </div>

                                    <div class="d-grid gap-2">
                                        <button class="btn red-btn" [disabled]="!isOtpValid"
                                            (click)="openBusinessInfoModal(otp)" type="button"> Continue</button>
                                    </div>
                                    <div class="note d-flex align-items-center">
                                        <span class="icon">🔒</span>
                                        <span> Your information is completely safe with us </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-signup></app-signup>